const applyRequiredValidation = (value) => {
    return !value;
}

const applyRegExValidation = (value, validation) => {
    const re = new RegExp(validation.rule);

    const result = re.test(value.toString());
    return !result;
}

const applyValidation = (form, validation, fieldErrorFlags) => {

    const { inputId } = validation;
    const value = form.data[inputId] ?? '';

    if (typeof value === 'undefined') {
        fieldErrorFlags[inputId] = `Data model does not match schema. ${inputId} is missing`;
        return false;
    }

    const fieldValue = value.toString().trim();
    let result = null;
    
    switch (validation.rule) {
        case 'required':
            result = applyRequiredValidation(fieldValue, validation);
            break;
        default:
            result = applyRegExValidation(fieldValue, validation);
    }
    
    if (result) {
        fieldErrorFlags[inputId] = result.message ?? validation.message;
    }
}

const validate = (form, field) => {
    let fieldErrorFlags = {};

    const validationRules = field
        ? form.validationRules?.filter(v => v.inputId === field)
        : form.validationRules;
    
    if (!validationRules) {
        return null;
    }

    validationRules.map(validation => {
        applyValidation(form, validation, fieldErrorFlags);
    });
    
    return fieldErrorFlags;
}

const formHelpers = {
    validateForm(form) {
        return validate(form, null);
    },

    validateField(form, field) {
        return validate(form, field);
    },

    isRequired(form, inputId) {
        return form.validationRules?.some(rule => rule.inputId === inputId && rule.rule === 'required')
    },

    isFieldRequired(form, field) {
        return this.isRequired(form, field.name) || field.required;
    },
    
    getError(form, inputId) {
        return form.fieldErrorFlags ? form.fieldErrorFlags[inputId] : "";
    }
}

export default formHelpers;
